"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useShipmentToken = exports.useShipmentTokenApi = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
const LoggerContext_1 = require("../../../lib/LoggerContext");
const SHIPMENT_TOKEN_QUERY_KEY = 'shipmentTokenQuery';
const useShipmentTokenApi = (shipmentId) => {
    const config = (0, ConfigContext_1.useConfigContext)();
    const { logError } = (0, LoggerContext_1.useLoggerContext)();
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    return async () => {
        const url = `${config.SHIPPING_ENDPOINT}/api/websockets?shipmentId=${shipmentId}`;
        try {
            const response = await ui_platform_http_1.HttpBaseApi.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        }
        catch (error) {
            logError(`Fetch Shipment Token failed: ${error}`);
            throw error;
        }
    };
};
exports.useShipmentTokenApi = useShipmentTokenApi;
const useShipmentToken = (shipmentID, enabled) => {
    const fetchShipmentTokenApi = (0, exports.useShipmentTokenApi)(shipmentID);
    return (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: [SHIPMENT_TOKEN_QUERY_KEY],
        queryFn: fetchShipmentTokenApi,
        enabled,
    });
};
exports.useShipmentToken = useShipmentToken;
//# sourceMappingURL=useShipmentToken.js.map